<template>

  <a-row type="flex" v-if="employee.operation[0]">
    <a-col class="team_employee" v-for="(item, index) in employee.operation"
           v-on:mouseover="employee.operation[index].active = true"
           v-on:mouseleave="employee.operation[index].active = false"
           :key="index">
      <img :src="item.picture" class="image">
      <h1 class="team_employee_name" v-if="employee.operation[index].active">{{ employee.operation[index].name_en }}</h1>
    </a-col>
  </a-row>

</template>

<script>
import axios from "axios";
import {reactive, onMounted} from 'vue'

export default {
  name: 'Team_operation_en_m',
  setup() {
    let employee = reactive({
      operation: [],
    })

    onMounted(() => {
      axios.get('https://sig-china.com:8081/api/employee/operation')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {

              employee.operation.push(res.data[i])

            }
            employee.operation.sort((a, b) => {
              return a['id'] - b['id']
            })
            for (let i = 0; i < employee.operation.length; i++) {
              employee.operation[i]['picture'] = 'https://sig-china.com' + employee.operation[i]['picture']
              employee.operation[i].active = false
            }
          })
    })

    return {employee}
  }
}
</script>

<style scoped>
.team_employee {
  width: 50vw;
  align-items: center;
  justify-content: center;
  position: relative;
}

.image {
  width: 50vw;

}

.team_employee_name {
  z-index: 2;
  position: absolute;
  bottom: 3vh;
  left: 2vw;
}

.image:hover {
  opacity: 0.5;
}

</style>
